export const CUSTOM_VIEW_STATUS_CHANGE_MESSAGE_TYPE = 'CUSTOM_VIEW_STATUS_CHANGE';